import { render } from "./BaseSwitch.vue?vue&type=template&id=0ebe7c76"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"
script.render = render

export default script